import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, ButtonGroup, Form } from 'react-bootstrap';
import { 
  FaArrowUp,
  FaArrowDown,
  FaSpinner,
  FaCalendarDay,
  FaCalendarPlus,
  FaExclamationTriangle,
  FaClock,
  FaFilter,
  FaSync
} from 'react-icons/fa';
import { 
  BarChart, 
  Bar, 
  Line, 
  PieChart, 
  Pie, 
  Cell, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend, 
  ResponsiveContainer, 
  ComposedChart 
} from 'recharts';
import '../../responsive.css';
import { collection, getDocs } from 'firebase/firestore';
// import { db } from '../../services/firebaseConnection'; 
import { useFirebaseConnection } from "../../services/useFirebaseConnection";
import { toast } from 'react-toastify';

const Dashboard = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [totalClientes, setTotalClientes] = useState(0);
  const [totalAnuncios, setTotalAnuncios] = useState(0);
  const [dadosPlanos, setDadosPlanos] = useState([]);
  const [dadosControleFinanceiro, setDadosControleFinanceiro] = useState([]);
  const [parcelasAVencer, setParcelasAVencer] = useState([]);
  const [filtroVencimento, setFiltroVencimento] = useState('vencidos');
  const [filtroAvancado, setFiltroAvancado] = useState(false);
  const [diasPersonalizados, setDiasPersonalizados] = useState(7);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { db } = useFirebaseConnection();
  
  // NOVOS ESTADOS PARA FILTROS POR ANO
  const [filtroAno, setFiltroAno] = useState('esse_ano');
  const [anoPersonalizado, setAnoPersonalizado] = useState(new Date().getFullYear());
  const [anosDisponiveis, setAnosDisponiveis] = useState([]);
  
  // Estados para dados financeiros
  const [dadosFinanceiros, setDadosFinanceiros] = useState({
    saldoAtual: 0,
    faturamentoMensal: 0,
    evolucaoFaturamento: [],
    estatisticas: {
      saldo: { variacao: 0, tendencia: 'positive', descricao: 'desde o mês passado' },
      faturamento: { variacao: 0, tendencia: 'positive', descricao: 'desde o mês passado' },
      clientes: { variacao: 0, tendencia: 'positive', descricao: 'novos este mês' }
    }
  });

  // Função para calcular a duração em dias entre duas datas
  const calcularDuracaoEmDias = (dataInicio, dataTermino) => {
    if (!dataInicio || !dataTermino) return 0;
    
    try {
      const inicio = new Date(dataInicio);
      const termino = new Date(dataTermino);
      
      if (isNaN(inicio.getTime()) || isNaN(termino.getTime())) {
        return 0;
      }
      
      const diffTime = Math.abs(termino - inicio);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      return diffDays;
    } catch (error) {
      toast.error('Erro ao calcular duração');
      console.error('Erro ao calcular duração:', error);
      return 0;
    }
  };

  // Função para identificar o tipo de plano baseado na duração
  const identificarTipoPlano = (dataInicio, dataTermino) => {
    const duracaoEmDias = calcularDuracaoEmDias(dataInicio, dataTermino);
    
    if (duracaoEmDias === 0) return 'Não Definido';
    if (duracaoEmDias <= 35) return 'Mensal';
    if (duracaoEmDias <= 70) return 'Bimestral';
    if (duracaoEmDias <= 100) return 'Trimestral';
    if (duracaoEmDias <= 200) return 'Semestral';
    if (duracaoEmDias <= 400) return 'Anual';
    
    return 'Personalizado';
  };

  // Cores para os diferentes tipos de planos
  const coresPlanos = {
    'Mensal': '#4361ee',
    'Bimestral': '#3f37c9',
    'Trimestral': '#7209b7',
    'Semestral': '#f72585',
    'Anual': '#4cc9f0',
    'Personalizado': '#f8961e',
    'Não Definido': '#6c757d'
  };

  // Função para formatar valor em moeda
  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valor);
  };

  // Função para formatar percentual
  const formatarPercentual = (valor) => {
    return `${valor >= 0 ? '+' : ''}${valor}%`;
  };

  // FUNÇÃO CORRIGIDA para formatar data
const formatarData = (dataString) => {
  if (!dataString) return '-';
  try {
    // 1. Cria o objeto Date a partir da string
    const data = new Date(dataString);

    // 2. Extrai o ano, mês e dia em UTC para evitar problemas de fuso
    const ano = data.getUTCFullYear();
    const mes = data.getUTCMonth() + 1; // Meses são de 0 a 11, então somamos 1
    const dia = data.getUTCDate();

    // 3. Formata a data manualmente no formato DD/MM/AAAA
    return `${String(dia).padStart(2, '0')}/${String(mes).padStart(2, '0')}/${ano}`;
  } catch {
    return '-';
  }
};


  // Funções para filtros de data
  const isDoMesAtual = (data) => {
    if (!data) return false;
    try {
      const hoje = new Date();
      const dataObj = new Date(data);
      return dataObj.getMonth() === hoje.getMonth() && 
             dataObj.getFullYear() === hoje.getFullYear();
    } catch {
      return false;
    }
  };

  const isDoMesAnterior = (data) => {
    if (!data) return false;
    try {
      const mesPassado = new Date();
      mesPassado.setMonth(mesPassado.getMonth() - 1);
      const dataObj = new Date(data);
      return dataObj.getMonth() === mesPassado.getMonth() && 
             dataObj.getFullYear() === mesPassado.getFullYear();
    } catch {
      return false;
    }
  };

    // Função Corrigida
  const calcularDiferencaDias = (dataVencimento) => {
    if (!dataVencimento) return null;
    try {
      // Cria a data de hoje e zera o horário para meia-noite
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      // Cria a data de vencimento e também zera o horário.
      // Isso é crucial para evitar que a data seja interpretada como UTC.
      const vencimento = new Date(dataVencimento);
      if (isNaN(vencimento.getTime())) return null;
      vencimento.setUTCHours(0, 0, 0, 0); // Usar setUTCHours para strings 'YYYY-MM-DD'

      // Calcula a diferença em milissegundos
      const diffTime = vencimento.getTime() - hoje.getTime();

      // Usa Math.round para obter o número de dias mais preciso
      return Math.round(diffTime / (1000 * 60 * 60 * 24));
    } catch (error) {
      console.error('Erro ao calcular diferença de dias:', error);
      return null;
    }
  };

  // Funções para verificar datas de vencimento
  const isVenceHoje = (dataVencimento) => {
    const diff = calcularDiferencaDias(dataVencimento);
    return diff === 0;
  };

  const isVenceAmanha = (dataVencimento) => {
    const diff = calcularDiferencaDias(dataVencimento);
    return diff === 1;
  };

  const isVencido = (dataVencimento) => {
    const diff = calcularDiferencaDias(dataVencimento);
    return diff !== null && diff < 0 && diff >= -7;
  };

  // Verificar se está vencido (qualquer mês)
  const isVencidoGeral = (dataVencimento) => {
    if (!dataVencimento) return false;
    try {
      const hoje = new Date();
      const vencimento = new Date(dataVencimento);
      return vencimento < hoje;
    } catch {
      return false;
    }
  };

  const isVenceProximosDias = (dataVencimento, dias) => {
    const diff = calcularDiferencaDias(dataVencimento);
    return diff !== null && diff >= 0 && diff <= dias;
  };

  // Função para obter status da parcela baseado na data
  const getStatusParcela = (dataVencimento, pago) => {
    if (pago) return 'pago';
    
    const diff = calcularDiferencaDias(dataVencimento);
    
    if (diff === null) return 'normal';
    if (diff < 0) return 'vencido';
    if (diff === 0) return 'vence_hoje';
    if (diff === 1) return 'vence_amanha';
    if (diff <= 7) return 'vence_semana';
    
    return 'normal';
  };

  // Função para calcular o total de anúncios dos pedidos ativos
  const calcularTotalAnunciosAtivos = (pedidos) => {
    try {
      
      let totalAnuncios = 0;
      let pedidosAtivos = 0;
      let pedidosSemQuantidade = 0;

      pedidos.forEach((pedido) => {
        // Verificar se o status é "ativo" (case-insensitive)
        if (pedido.status && pedido.status.toLowerCase() === 'ativo') {
          pedidosAtivos++;
          
          // Verificar se existe o campo quantidadeAnuncios
          if (pedido.quantidadeAnuncios !== undefined && pedido.quantidadeAnuncios !== null) {
            const quantidade = Number(pedido.quantidadeAnuncios);
            
            if (!isNaN(quantidade) && quantidade >= 0) {
              totalAnuncios += quantidade;
            } else {
              console.warn(`Pedido ${pedido.id}: quantidadeAnuncios inválida (${pedido.quantidadeAnuncios})`);
              pedidosSemQuantidade++;
            }
          } else {
            console.warn(`Pedido ${pedido.id}: campo quantidadeAnuncios não encontrado`);
            pedidosSemQuantidade++;
          }
        }
      });

      return totalAnuncios;

    } catch (error) {
      toast.error('Erro ao calcular total de anúncios');
      console.error('Erro ao calcular total de anúncios:', error);
      return 0;
    }
  };

  // NOVA FUNÇÃO: Calcular total de clientes ativos
  const calcularTotalClientesAtivos = (clientes) => {
    try {
      
      let clientesAtivos = 0;
      
      clientes.forEach((cliente) => {
        // Verificar se o status é "Ativo" (case-insensitive)
        if (cliente.status && cliente.status.toLowerCase() === 'ativo') {
          clientesAtivos++;
        }
      });

      return clientesAtivos;

    } catch (error) {
      toast.error('Erro ao calcular total de clientes ativos');
      console.error('Erro ao calcular total de clientes ativos:', error);
      return 0;
    }
  };

  // Filtrar apenas pedidos ativos na distribuição por planos
  const gerarDistribuicaoPlanosAtivos = (pedidos) => {
    try {
      
      const contagemPlanos = {};
      let pedidosAtivos = 0;
      
      pedidos.forEach((pedido) => {
        // Filtrar apenas pedidos ativos (case-insensitive)
        if (pedido.status && pedido.status.toLowerCase() === 'ativo') {
          pedidosAtivos++;
          
          // Identificar tipo de plano
          const tipoPlano = identificarTipoPlano(pedido.dataInicio, pedido.dataTermino);
          
          // Contar planos
          if (contagemPlanos[tipoPlano]) {
            contagemPlanos[tipoPlano]++;
          } else {
            contagemPlanos[tipoPlano] = 1;
          }
        }
      });
      
      // Converter para formato do gráfico
      const dadosFormatados = Object.entries(contagemPlanos).map(([nome, valor]) => ({
        nome,
        valor,
        cor: coresPlanos[nome] || '#6c757d'
      }));

      // Ordenar por quantidade (maior para menor)
      dadosFormatados.sort((a, b) => b.valor - a.valor);
      
      return dadosFormatados;
      
    } catch (error) {
      toast.error('Erro ao gerar distribuição de planos ativos');
      console.error('Erro ao gerar distribuição de planos ativos:', error);
      return [];
    }
  };

  // NOVA FUNÇÃO: Obter anos disponíveis baseado nas parcelas
  const obterAnosDisponiveis = (parcelas) => {
    try {
      const anos = new Set();
      const anoAtual = new Date().getFullYear();
      
      // Adicionar anos das parcelas existentes
      parcelas.forEach(parcela => {
        if (parcela && parcela.dataVencimento) {
          try {
            const ano = new Date(parcela.dataVencimento).getFullYear();
            if (!isNaN(ano)) {
              anos.add(ano);
            }
          } catch (error) {
            console.warn('Data inválida em parcela:', parcela.dataVencimento);
          }
        }
      });
      
      // Garantir que o ano atual e anterior estejam incluídos
      anos.add(anoAtual);
      anos.add(anoAtual - 1);
      
      return Array.from(anos).sort((a, b) => b - a); // Ordenar decrescente
    } catch (error) {
      console.error('Erro ao obter anos disponíveis:', error);
      return [new Date().getFullYear()];
    }
  };

  // NOVA FUNÇÃO: Filtrar dados por ano
  const filtrarDadosPorAno = (dados, filtroAno, anoPersonalizado) => {
    const anoAtual = new Date().getFullYear();
    
    switch (filtroAno) {
      case 'ano_passado':
        return dados.filter(item => {
          const [ano] = item.mesAno.split('-');
          return parseInt(ano) === (anoAtual - 1);
        });
      case 'esse_ano':
        return dados.filter(item => {
          const [ano] = item.mesAno.split('-');
          return parseInt(ano) === anoAtual;
        });
      case 'filtrar_por_ano':
        return dados.filter(item => {
          const [ano] = item.mesAno.split('-');
          return parseInt(ano) === anoPersonalizado;
        });
      default:
        return dados;
    }
  };

  // FUNÇÃO CORRIGIDA: Nova lógica para controle financeiro mensal
  const gerarControleFinanceiroMensal = (parcelas) => {
    try {
      
      const dadosPorMes = {};
      const hoje = new Date();
      const anoAtual = hoje.getFullYear();
      const mesAtual = hoje.getMonth();
      
      // Processar todas as parcelas
      parcelas.forEach(parcela => {
        if (!parcela || !parcela.dataVencimento) return;
        
        try {
          const dataVencimento = new Date(parcela.dataVencimento);
          const mesAno = `${dataVencimento.getFullYear()}-${String(dataVencimento.getMonth() + 1).padStart(2, '0')}`;

          
          if (!dadosPorMes[mesAno]) {
            dadosPorMes[mesAno] = {
              faturamentoEsperado: 0,
              valorPago: 0,
              valorAReceber: 0,
              inadimplencia: 0,
              temContas: false
            };
          }
          
          const valor = Number(parcela.valor) || 0;
          
          // Marcar que este mês tem contas
          dadosPorMes[mesAno].temContas = true;
          
          // Faturamento esperado (todas as parcelas do mês)
          dadosPorMes[mesAno].faturamentoEsperado += valor;
          
          if (parcela.pago) {
            // Valor pago sempre no mês de vencimento
            dadosPorMes[mesAno].valorPago += valor;
          } else {
            // Verificar se está vencido (inadimplência)
            if (dataVencimento < hoje) {
              // Parcela vencida e não paga - inadimplência no mês de vencimento
              dadosPorMes[mesAno].inadimplencia += valor;
            } else {
              // Parcela não vencida - valor a receber no mês de vencimento
              dadosPorMes[mesAno].valorAReceber += valor;
            }
          }
        } catch (error) {
          console.warn('Data inválida em parcela:', parcela.dataVencimento);
        }
      });
      
      // NOVA LÓGICA CORRIGIDA: Garantir pelo menos 10 meses
      const nomesMeses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
      
      // 1. Identificar meses passados que têm contas
      const mesesPassadosComContas = [];
      Object.entries(dadosPorMes).forEach(([mesAno, dados]) => {
        const [ano, mes] = mesAno.split('-');
        const dataDoMes = new Date(parseInt(ano), parseInt(mes) - 1);
        const dataAtual = new Date(anoAtual, mesAtual);
        
        if (dataDoMes < dataAtual && dados.temContas) {
          mesesPassadosComContas.push({
            mes: nomesMeses[parseInt(mes) - 1],
            mesAno,
            ano: parseInt(ano),
            mesNumero: parseInt(mes),
            ...dados,
            percentualInadimplencia: dados.faturamentoEsperado > 0 
              ? ((dados.inadimplencia / dados.faturamentoEsperado) * 100).toFixed(1)
              : 0
          });
        }
      });
      
      // 2. Adicionar próximos 2 meses (incluindo o atual)
      const proximosMeses = [];
      for (let i = 0; i < 2; i++) {
        const dataProxima = new Date(anoAtual, mesAtual + i);
        const mesAnoProximo = `${dataProxima.getFullYear()}-${String(dataProxima.getMonth() + 1).padStart(2, '0')}`;
        
        const dadosExistentes = dadosPorMes[mesAnoProximo] || {
          faturamentoEsperado: 0,
          valorPago: 0,
          valorAReceber: 0,
          inadimplencia: 0,
          temContas: false
        };
        
        proximosMeses.push({
          mes: nomesMeses[dataProxima.getMonth()],
          mesAno: mesAnoProximo,
          ano: dataProxima.getFullYear(),
          mesNumero: dataProxima.getMonth() + 1,
          ...dadosExistentes,
          percentualInadimplencia: dadosExistentes.faturamentoEsperado > 0 
            ? ((dadosExistentes.inadimplencia / dadosExistentes.faturamentoEsperado) * 100).toFixed(1)
            : 0
        });
      }
      
      // 3. Combinar meses passados + próximos 2 meses
      let mesesSelecionados = [...mesesPassadosComContas, ...proximosMeses];
      
      // 4. Se não tiver 10 meses, adicionar mais meses futuros
      if (mesesSelecionados.length < 10) {
        const mesesFaltantes = 10 - mesesSelecionados.length;
        
        for (let i = 2; i < 2 + mesesFaltantes; i++) {
          const dataFutura = new Date(anoAtual, mesAtual + i);
          const mesAnoFuturo = `${dataFutura.getFullYear()}-${String(dataFutura.getMonth() + 1).padStart(2, '0')}`;
          
          // Verificar se já existe
          if (!mesesSelecionados.find(m => m.mesAno === mesAnoFuturo)) {
            const dadosExistentes = dadosPorMes[mesAnoFuturo] || {
              faturamentoEsperado: 0,
              valorPago: 0,
              valorAReceber: 0,
              inadimplencia: 0,
              temContas: false
            };
            
            mesesSelecionados.push({
              mes: nomesMeses[dataFutura.getMonth()],
              mesAno: mesAnoFuturo,
              ano: dataFutura.getFullYear(),
              mesNumero: dataFutura.getMonth() + 1,
              ...dadosExistentes,
              percentualInadimplencia: dadosExistentes.faturamentoEsperado > 0 
                ? ((dadosExistentes.inadimplencia / dadosExistentes.faturamentoEsperado) * 100).toFixed(1)
                : 0
            });
          }
        }
      }
      
      // 5. Ordenar por data e remover duplicatas
      const mesesFinais = mesesSelecionados
        .filter((mes, index, self) => 
          index === self.findIndex(m => m.mesAno === mes.mesAno)
        )
        .sort((a, b) => a.mesAno.localeCompare(b.mesAno));
      
      return mesesFinais;
      
    } catch (error) {
      console.error('Erro ao gerar controle financeiro:', error);
      return [];
    }
  };

  // Função para calcular saldo atual
  const calcularSaldoAtual = (contas, parcelas) => {
    try {
      // Receitas de contas a receber pagas
      const receitasContas = contas
        .filter(c => c && c.tipo === 'receber' && c.status === 'pago')
        .reduce((sum, c) => sum + (Number(c.valor) || 0), 0);
        
      // Receitas de parcelas pagas
      const receitasParcelas = parcelas
        .filter(p => p && p.pago)
        .reduce((sum, p) => sum + (Number(p.valorPago ?? p.valor) || 0), 0);
        
      // Despesas de contas a pagar pagas
      const despesas = contas
        .filter(c => c && c.tipo === 'pagar' && c.status === 'pago')
        .reduce((sum, c) => sum + (Number(c.valor) || 0), 0);
        
      return (receitasContas + receitasParcelas) - despesas;
    } catch (error) {
      console.error('Erro ao calcular saldo:', error);
      return 0;
    }
  };

  // Função para calcular faturamento mensal
  const calcularFaturamentoMensal = (contas, parcelas) => {
    try {
      // Receitas de contas pagas no mês atual
      const receitasContas = contas
        .filter(c => c && c.tipo === 'receber' && c.status === 'pago' && isDoMesAtual(c.dataPagamento))
        .reduce((sum, c) => sum + (Number(c.valor) || 0), 0);
        
      // Receitas de parcelas pagas no mês atual
      const receitasParcelas = parcelas
        .filter(p => p && p.pago && isDoMesAtual(p.dataPagamento))
        .reduce((sum, p) => sum + (Number(p.valor) || 0), 0);
        
      return receitasContas + receitasParcelas;
    } catch (error) {
      console.error('Erro ao calcular faturamento mensal:', error);
      return 0;
    }
  };

  // Função para gerar evolução do faturamento
  const gerarEvolucaoFaturamento = (contas, parcelas) => {
    try {
      const dadosPorMes = {};
      
      // Processar receitas (contas a receber pagas)
      contas.forEach(conta => {
        if (conta && conta.tipo === 'receber' && conta.status === 'pago' && conta.dataPagamento) {
          try {
            const data = new Date(conta.dataPagamento);
            const mesAno = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
            
            if (!dadosPorMes[mesAno]) {
              dadosPorMes[mesAno] = { faturamento: 0, gastos: 0, lucro: 0 };
            }
            
            dadosPorMes[mesAno].faturamento += (Number(conta.valor) || 0);
          } catch (error) {
            toast.warn('Data inválida em conta a receber:', conta.dataPagamento);
            console.warn('Data inválida em conta a receber:', conta.dataPagamento);
          }
        }
      });
      
      // Processar receitas (parcelas pagas)
      parcelas.forEach(parcela => {
        if (parcela && parcela.pago && parcela.dataPagamento) {
          try {
            const data = new Date(parcela.dataPagamento);
            const mesAno = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
            
            if (!dadosPorMes[mesAno]) {
              dadosPorMes[mesAno] = { faturamento: 0, gastos: 0, lucro: 0 };
            }
            
            // dadosPorMes[mesAno].faturamento += (Number(parcela.valor) || 0);
            dadosPorMes[mesAno].faturamento += (Number(parcela.valorPago ?? parcela.valor) || 0);
          } catch (error) {
            toast.warn('Data inválida em parcela:', parcela.dataPagamento);
            console.warn('Data inválida em parcela:', parcela.dataPagamento);
          }
        }
      });
      
      // Processar gastos (contas a pagar pagas)
      contas.forEach(conta => {
        if (conta && conta.tipo === 'pagar' && conta.status === 'pago' && conta.dataPagamento) {
          try {
            const data = new Date(conta.dataPagamento);
            const mesAno = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
            
            if (!dadosPorMes[mesAno]) {
              dadosPorMes[mesAno] = { faturamento: 0, gastos: 0, lucro: 0 };
            }
            
            dadosPorMes[mesAno].gastos += (Number(conta.valor) || 0);
          } catch (error) {
            toast.warn('Data inválida em conta a pagar:', conta.dataPagamento);
            console.warn('Data inválida em conta a pagar:', conta.dataPagamento);
          }
        }
      });
      
      // Calcular lucro e converter para array
      const meses = Object.entries(dadosPorMes)
        .map(([mesAno, dados]) => {
          const [ano, mes] = mesAno.split('-');
          const nomesMeses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
          
          // Calcular lucro
          dados.lucro = dados.faturamento - dados.gastos;
          
          return {
            mes: nomesMeses[parseInt(mes) - 1],
            mesAno,
            faturamento: dados.faturamento,
            gastos: dados.gastos,
            lucro: dados.lucro
          };
        })
        .sort((a, b) => a.mesAno.localeCompare(b.mesAno))
        .slice(-6); // Últimos 6 meses
        
      return meses;
    } catch (error) {
      toast.error('Erro ao gerar evolução do faturamento');
      console.error('Erro ao gerar evolução do faturamento:', error);
      return [];
    }
  };

  // Função para calcular estatísticas comparativas
  const calcularEstatisticas = (dadosAtuais, dadosAnteriores, tipo) => {
    try {
      if (dadosAnteriores === 0) {
        return {
          variacao: dadosAtuais > 0 ? 100 : 0,
          tendencia: dadosAtuais > 0 ? 'positive' : 'neutral',
          descricao: tipo === 'clientes' ? 'novos este mês' : 'desde o mês passado'
        };
      }
      
      const variacao = ((dadosAtuais - dadosAnteriores) / dadosAnteriores) * 100;
      return {
        variacao: Math.round(variacao * 10) / 10, // Arredondar para 1 casa decimal
        tendencia: variacao >= 0 ? 'positive' : 'negative',
        descricao: tipo === 'clientes' ? 'novos este mês' : 'desde o mês passado'
      };
    } catch (error) {
      toast.error('Erro ao calcular estatísticas');
      console.error('Erro ao calcular estatísticas:', error);
      return {
        variacao: 0,
        tendencia: 'neutral',
        descricao: 'dados indisponíveis'
      };
    }
  };

  // Função para buscar e processar dados financeiros
  const fetchDadosFinanceiros = async () => {
    try {
      setLoading(true);
      setError('');
      
      // Buscar contas
      let contas = [];
      try {
        const contasSnapshot = await getDocs(collection(db, 'contas'));
        contas = contasSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

      } catch (error) {
        console.warn('Erro ao buscar contas (coleção pode não existir):', error);
      }
      
      // Buscar pedidos
      const pedidosSnapshot = await getDocs(collection(db, 'pedidos'));
      const pedidos = pedidosSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Calcular total de anúncios ativos
      const totalAnunciosCalculado = calcularTotalAnunciosAtivos(pedidos);
      setTotalAnuncios(totalAnunciosCalculado);

      // Gerar distribuição de planos apenas para pedidos ativos
      const dadosFormatadosPlanos = gerarDistribuicaoPlanosAtivos(pedidos);
      setDadosPlanos(dadosFormatadosPlanos);

      // Processar parcelas dos pedidos
      const todasParcelas = [];
      
      pedidos.forEach((pedido) => {
        // Processar parcelas do pedido
        if (pedido.parcelas && Array.isArray(pedido.parcelas)) {
          pedido.parcelas.forEach((parcela, index) => {
            if (!parcela || typeof parcela !== 'object') {
              toast.warn(`Parcela inválida no pedido ${pedido.id}:`, parcela);
              console.warn('Parcela inválida encontrada:', parcela);
              return;
            }

            const parcelaData = {
              id: `parcela_${pedido.id}_${parcela.numero || (index + 1)}`,
              clienteNome: pedido.clienteNome || 'Cliente não informado',
              clienteId: pedido.clienteId || '',
              pedidoId: pedido.id,
              numeroParcela: parcela.numero || (index + 1),
              totalParcelas: pedido.parcelas.length,
              valor: Number(parcela.valor) || 0,
              dataVencimento: parcela.dataVencimento || '',
              pago: parcela.pago || false,
              dataPagamento: parcela.dataPagamento || '',
              status: getStatusParcela(parcela.dataVencimento, parcela.pago),
              diasParaVencimento: calcularDiferencaDias(parcela.dataVencimento)
            };
            
            todasParcelas.push(parcelaData);
          });
        }
      });

      // NOVA LÓGICA: Obter anos disponíveis
      const anosCalculados = obterAnosDisponiveis(todasParcelas);
      setAnosDisponiveis(anosCalculados);

      // Gerar dados de controle financeiro com nova lógica CORRIGIDA
      const dadosControleFinanceiroCalculado = gerarControleFinanceiroMensal(todasParcelas);
      
      // Aplicar filtro por ano
      const dadosFiltrados = filtrarDadosPorAno(dadosControleFinanceiroCalculado, filtroAno, anoPersonalizado);
      setDadosControleFinanceiro(dadosFiltrados);

      // Calcular dados financeiros
      const saldoAtual = calcularSaldoAtual(contas, todasParcelas);
      const faturamentoMensal = calcularFaturamentoMensal(contas, todasParcelas);
      const evolucaoFaturamento = gerarEvolucaoFaturamento(contas, todasParcelas);
      
      // Calcular dados do mês anterior para comparação
      const faturamentoMesAnterior = contas
        .filter(c => c && c.tipo === 'receber' && c.status === 'pago' && isDoMesAnterior(c.dataPagamento))
        .reduce((sum, c) => sum + (Number(c.valor) || 0), 0) +
        todasParcelas
        .filter(p => p && p.pago && isDoMesAnterior(p.dataPagamento))
        .reduce((sum, p) => sum + (Number(p.valor) || 0), 0);

      // CORREÇÃO: Buscar clientes e filtrar apenas os ativos
      const clientesSnapshot = await getDocs(collection(db, 'clientes'));
      const todosClientes = clientesSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      const totalClientesAtivos = calcularTotalClientesAtivos(todosClientes);
      
      // Calcular novos clientes do mês (simulado - seria necessário campo de data de cadastro)
      const novosClientesMes = Math.max(1, Math.floor(totalClientesAtivos * 0.1)); // 10% como estimativa

      // Calcular estatísticas
      const estatisticas = {
        saldo: calcularEstatisticas(saldoAtual, saldoAtual * 0.9, 'saldo'), // Simulando crescimento de 10%
        faturamento: calcularEstatisticas(faturamentoMensal, faturamentoMesAnterior, 'faturamento'),
        clientes: {
          variacao: novosClientesMes,
          tendencia: 'positive',
          descricao: 'novos este mês'
        }
      };

      // Ordenar parcelas por data de vencimento
      todasParcelas.sort((a, b) => {
        if (!a.dataVencimento) return 1;
        if (!b.dataVencimento) return -1;
        return new Date(a.dataVencimento) - new Date(b.dataVencimento);
      });

      // Atualizar estados
      setDadosFinanceiros({
        saldoAtual,
        faturamentoMensal,
        evolucaoFaturamento,
        estatisticas
      });
      
      setParcelasAVencer(todasParcelas);
      setTotalClientes(totalClientesAtivos); // CORREÇÃO: Usar apenas clientes ativos
      
      
    } catch (error) {
      toast.error('Erro ao buscar dados financeiros');
      console.error('Erro ao buscar dados financeiros:', error);
      setError('Erro ao carregar dados financeiros');
      
      setDadosPlanos([
        { nome: 'Erro ao carregar', valor: 0, cor: '#6c757d' }
      ]);
      setParcelasAVencer([]);
    } finally {
      setLoading(false);
    }
  };

  // NOVO EFFECT: Reagir a mudanças no filtro de ano
  useEffect(() => {
    if (dadosControleFinanceiro.length > 0) {
      // Reprocessar dados quando filtro de ano mudar
      fetchDadosFinanceiros();
    }
  }, [filtroAno, anoPersonalizado]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    fetchDadosFinanceiros();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Filtrar parcelas baseado no filtro selecionado
  const parcelasFiltradas = React.useMemo(() => {
    if (!Array.isArray(parcelasAVencer)) {
      toast.warn('parcelasAVencer não é um array válido');
      console.warn('parcelasAVencer não é um array:', parcelasAVencer);
      return [];
    }

    try {
      const filtradas = parcelasAVencer.filter(parcela => {
        if (!parcela || typeof parcela !== 'object') {
          toast.warn('Parcela inválida encontrada:', parcela);
          console.warn('Parcela inválida no filtro:', parcela);
          return false;
        }

        if (parcela.pago) return false;
        
        switch (filtroVencimento) {
          case 'vence_hoje':
            return isVenceHoje(parcela.dataVencimento);
          case 'vence_amanha':
            return isVenceAmanha(parcela.dataVencimento);
          case 'vencidos':
            return isVencidoGeral(parcela.dataVencimento);
          case 'proximos_dias':
            return isVenceProximosDias(parcela.dataVencimento, diasPersonalizados);
          default:
            return false;
        }
      });

      return Array.isArray(filtradas) ? filtradas.slice(0, 15) : [];
    } catch (error) {
      toast.error('Erro ao filtrar parcelas');
      console.error('Erro ao filtrar parcelas:', error);
      return [];
    }
  }, [parcelasAVencer, filtroVencimento, diasPersonalizados]);

  // Contar parcelas por categoria
  const contadores = React.useMemo(() => {
    if (!Array.isArray(parcelasAVencer)) {
      return {
        vence_hoje: 0,
        vence_amanha: 0,
        vencidos: 0,
        proximos_dias: 0
      };
    }

    try {
      return {
        vence_hoje: parcelasAVencer.filter(p => p && !p.pago && isVenceHoje(p.dataVencimento)).length,
        vence_amanha: parcelasAVencer.filter(p => p && !p.pago && isVenceAmanha(p.dataVencimento)).length,
        vencidos: parcelasAVencer.filter(p => p && !p.pago && isVencidoGeral(p.dataVencimento)).length,
        proximos_dias: parcelasAVencer.filter(p => p && !p.pago && isVenceProximosDias(p.dataVencimento, diasPersonalizados)).length
      };
    } catch (error) {
      toast.error('Erro ao contar parcelas');
      console.error('Erro ao contar parcelas:', error);
      return {
        vence_hoje: 0,
        vence_amanha: 0,
        vencidos: 0,
        proximos_dias: 0
      };
    }
  }, [parcelasAVencer, diasPersonalizados]);

  // Função para renderizar status da parcela com cores
  const renderStatusParcela = (parcela) => {
    if (!parcela) return <span className="badge bg-secondary">Erro</span>;
    
    const { status, diasParaVencimento } = parcela;
    
    switch (status) {
      case 'vence_hoje':
        return <span>Vence Hoje</span>;
      case 'vence_amanha':
        return <span>Vence Amanhã</span>;
      case 'vencido':
        return <span>Vencido ({diasParaVencimento !== null ? Math.abs(diasParaVencimento) : '?'} dias)</span>;
      case 'vence_semana':
        return <span>Em {diasParaVencimento || '?'} dias</span>;
      case 'pago':
        return <span>Pago</span>;
      default:
        return <span>Pendente</span>;
    }
  };

  // Função para obter cor da linha baseada na urgência
  const getRowClass = (parcela) => {
    if (!parcela) return '';
    
    switch (parcela.status) {
      case 'vence_hoje':
        return 'table-danger';
      case 'vence_amanha':
        return 'table-warning';
      case 'vencido':
        return 'table-light';
      default:
        return '';
    }
  };

  // Determinar o número de colunas com base na largura da tela
  const getStatsGridColumns = () => {
    if (windowWidth < 576) return 1;
    if (windowWidth < 992) return 2;
    return 4;
  };

  // Tooltip customizado para o gráfico de pizza
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      const total = dadosPlanos.reduce((sum, item) => sum + item.valor, 0);
      const percentage = total > 0 ? ((data.value / total) * 100).toFixed(1) : 0;
      
      return (
        <div className="custom-tooltip" style={{
          backgroundColor: 'white',
          padding: '10px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <p style={{ margin: 0, fontWeight: 'bold' }}>{data.payload.nome}</p>
          <p style={{ margin: 0, color: data.payload.cor }}>
            {data.value} pedidos ({percentage}%)
          </p>
        </div>
      );
    }
    return null;
  };

  // Tooltip customizado para controle financeiro
  const CustomTooltipControleFinanceiro = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip" style={{
          backgroundColor: 'white',
          padding: '10px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <p style={{ margin: 0, fontWeight: 'bold' }}>{label}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ margin: 0, color: entry.color }}>
              {entry.name}: {formatarMoeda(entry.value)}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="page-content">
      
      {/* Exibir erro se houver */}
      {error && (
        <div className="alert alert-warning" role="alert">
          {error}
        </div>
      )}
      
      {/* Cards de estatísticas responsivos */}
      <div className="stats-grid" style={{ gridTemplateColumns: `repeat(${getStatsGridColumns()}, 1fr)` }}>
        <div className="stat-card">
          <div className="stat-title">Saldo Atual</div>
          <div className="stat-value">
            {loading ? <FaSpinner className="fa-spin" /> : formatarMoeda(dadosFinanceiros.saldoAtual)}
          </div>
          <div className={`stat-change ${dadosFinanceiros.estatisticas.saldo.tendencia}`}>
            {dadosFinanceiros.estatisticas.saldo.tendencia === 'positive' ? (
              <FaArrowUp className="stat-icon" />
            ) : dadosFinanceiros.estatisticas.saldo.tendencia === 'negative' ? (
              <FaArrowDown className="stat-icon" />
            ) : null}
            {formatarPercentual(dadosFinanceiros.estatisticas.saldo.variacao)} {dadosFinanceiros.estatisticas.saldo.descricao}
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-title">Faturamento Mensal</div>
          <div className="stat-value">
            {loading ? <FaSpinner className="fa-spin" /> : formatarMoeda(dadosFinanceiros.faturamentoMensal)}
          </div>
          <div className={`stat-change ${dadosFinanceiros.estatisticas.faturamento.tendencia}`}>
            {dadosFinanceiros.estatisticas.faturamento.tendencia === 'positive' ? (
              <FaArrowUp className="stat-icon" />
            ) : dadosFinanceiros.estatisticas.faturamento.tendencia === 'negative' ? (
              <FaArrowDown className="stat-icon" />
            ) : null}
            {formatarPercentual(dadosFinanceiros.estatisticas.faturamento.variacao)} {dadosFinanceiros.estatisticas.faturamento.descricao}
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-title">Total de Clientes Ativos</div>
          <div className="stat-value">{loading ? <FaSpinner className="fa-spin" /> : totalClientes}</div>
          <div className={`stat-change ${dadosFinanceiros.estatisticas.clientes.tendencia}`}>
            <FaArrowUp className="stat-icon" />
            {dadosFinanceiros.estatisticas.clientes.variacao} {dadosFinanceiros.estatisticas.clientes.descricao}
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-title">Total de Anúncios</div>
          <div className="stat-value">{loading ? <FaSpinner className="fa-spin" /> : totalAnuncios}</div>
          <div className="stat-change positive">
            <FaArrowUp className="stat-icon" /> Anúncios ativos
          </div>
        </div>
      </div>
      
      {/* Gráficos responsivos */}
      <div className={windowWidth < 992 ? "" : "charts-grid"}>
        <div className="card mb-3">
          <div className="card-header">
            <h5 className="card-title">
              Evolução do Faturamento
              {loading && (
                <span className="text-muted ms-2">
                  <FaSpinner className="fa-spin me-1" />
                  Carregando...
                </span>
              )}
            </h5>
          </div>
          <div className="card-body">
            {dadosFinanceiros.evolucaoFaturamento.length > 0 && !loading ? (
              <ResponsiveContainer width="100%" height={300}>
                <ComposedChart data={dadosFinanceiros.evolucaoFaturamento}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                  <XAxis 
                    dataKey="mes" 
                    stroke="#6b7280"
                    fontSize={12}
                  />
                  <YAxis 
                    stroke="#6b7280"
                    fontSize={12}
                    tickFormatter={(value) => {
                      if (value >= 1000) {
                        return `R$ ${(value / 1000).toFixed(0)}k`;
                      }
                      return `R$ ${value}`;
                    }}
                  />
                  <Tooltip 
                    formatter={(value, name) => [formatarMoeda(value), name]}
                    labelStyle={{ color: '#374151' }}
                    contentStyle={{ 
                      backgroundColor: 'white', 
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                    }}
                  />
                  <Legend 
                    wrapperStyle={{ paddingTop: '20px' }}
                  />
                  
                  {/* Barra do Faturamento */}
                  <Bar 
                    dataKey="faturamento" 
                    fill="#4361ee" 
                    name="Faturamento"
                    radius={[2, 2, 0, 0]}
                  />
                  
                  {/* Barra dos Gastos */}
                  <Bar 
                    dataKey="gastos" 
                    fill="#f72585" 
                    name="Gastos"
                    radius={[2, 2, 0, 0]}
                  />
                  
                  {/* Linha do Lucro */}
                  <Line 
                    type="monotone" 
                    dataKey="lucro" 
                    stroke="#4cc9f0" 
                    strokeWidth={3}
                    name="Lucro"
                    dot={{ fill: '#4cc9f0', strokeWidth: 2, r: 5 }}
                    activeDot={{ r: 7, stroke: '#4cc9f0', strokeWidth: 2 }}
                  />
                </ComposedChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-center py-5">
                <p className="text-muted">
                  {loading ? (
                    <>
                      <FaSpinner className="fa-spin me-2" />
                      Carregando evolução do faturamento...
                    </>
                  ) : (
                    'Dados insuficientes para gerar gráfico de evolução'
                  )}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Controle Financeiro - COM NOVA LÓGICA CORRIGIDA E FILTROS */}
        <div className="card mb-3">
          <div className="card-header">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <h5 className="card-title mb-0">
                Controle Financeiro
                {loading && (
                  <span className="text-muted ms-2">
                    <FaSpinner className="fa-spin me-1" />
                    Carregando...
                  </span>
                )}
              </h5>
              
              {/* FILTROS POR ANO */}
              <div className="d-flex gap-2 align-items-center flex-wrap">
                <Form.Select
                  size="sm"
                  value={filtroAno}
                  onChange={(e) => setFiltroAno(e.target.value)}
                  style={{ width: 'auto', minWidth: '120px' }}
                >
                  <option value="ano_passado">Ano Passado</option>
                  <option value="esse_ano">Este Ano</option>
                  <option value="filtrar_por_ano">Filtrar por Ano</option>
                </Form.Select>
                
                {filtroAno === 'filtrar_por_ano' && (
                  <Form.Select
                    size="sm"
                    value={anoPersonalizado}
                    onChange={(e) => setAnoPersonalizado(parseInt(e.target.value))}
                    style={{ width: 'auto', minWidth: '80px' }}
                  >
                    {anosDisponiveis.map(ano => (
                      <option key={ano} value={ano}>{ano}</option>
                    ))}
                  </Form.Select>
                )}
              </div>
            </div>
          </div>
          <div className="card-body">
            {dadosControleFinanceiro.length > 0 && !loading ? (
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={dadosControleFinanceiro}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                  <XAxis 
                    dataKey="mes" 
                    stroke="#6b7280"
                    fontSize={12}
                  />
                  <YAxis 
                    stroke="#6b7280"
                    fontSize={12}
                    tickFormatter={(value) => {
                      if (value >= 1000) {
                        return `R$ ${(value / 1000).toFixed(0)}k`;
                      }
                      return `R$ ${value}`;
                    }}
                  />
                  <Tooltip content={<CustomTooltipControleFinanceiro />} />
                  <Legend />
                  
                  {/* Valor Pago - COR MANTIDA */}
                  <Bar 
                    dataKey="valorPago" 
                    stackId="a"
                    fill="#4361ee" 
                    name="Valor Pago"
                  />
                  
                  {/* Valor a Receber - COR MANTIDA */}
                  <Bar 
                    dataKey="valorAReceber" 
                    stackId="a"
                    fill="#6b7280" 
                    name="A Receber"
                  />
                  
                  {/* Inadimplência - COR MANTIDA */}
                  <Bar 
                    dataKey="inadimplencia" 
                    stackId="a"
                    fill="#f72585" 
                    name="Inadimplência"
                  />
                </BarChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-center py-5">
                <p className="text-muted">
                  {loading ? (
                    <>
                      <FaSpinner className="fa-spin me-2" />
                      Carregando controle financeiro...
                    </>
                  ) : (
                    'Dados insuficientes para gerar controle financeiro'
                  )}
                </p>
              </div>
            )}
          </div>
        </div>
        
      </div>
      
      <div className={windowWidth < 992 ? "" : "charts-grid"}>
        {/* Distribuição por Planos (apenas pedidos ativos) */}
        <div className="card mb-3">
          <div className="card-header">
            <h5 className="card-title">
              Distribuição por Planos (Pedidos Ativos)
              {loading && (
                <span className="text-muted ms-2">
                  <FaSpinner className="fa-spin me-1" />
                  Carregando...
                </span>
              )}
            </h5>
          </div>
          <div className="card-body">
            {dadosPlanos.length > 0 && !loading ? (
              <ResponsiveContainer width="100%" minHeight={300} height="90%">
                <PieChart>
                  <Pie
                    data={dadosPlanos}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius="70%"
                    fill="#8884d8"
                    dataKey="valor"
                    nameKey="nome"
                    label={({ nome, percent }) => `${nome}: ${(percent * 100).toFixed(0)}%`}
                  >
                    {dadosPlanos.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.cor} />
                    ))}
                  </Pie>
                  <Tooltip content={<CustomTooltip />} />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-center py-5">
                <p className="text-muted">
                  {loading ? (
                    <>
                      <FaSpinner className="fa-spin me-2" />
                      Carregando dados dos pedidos ativos...
                    </>
                  ) : (
                    'Nenhum pedido ativo encontrado'
                  )}
                </p>
              </div>
            )}
          </div>
        </div>
        
        {/* Parcelas a Vencer */}
        <div className="card mb-3">
          <div className="card-header">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0">
                Parcelas a Vencer
                {loading && (
                  <span className="text-muted ms-2">
                    <FaSpinner className="fa-spin me-1" />
                    Carregando...
                  </span>
                )}
              </h5>
              <div className="d-flex gap-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setFiltroAvancado(!filtroAvancado)}
                >
                  <FaFilter className="me-1" />
                  {filtroAvancado ? 'Ocultar' : 'Filtros'}
                </Button>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={fetchDadosFinanceiros}
                  disabled={loading}
                >
                  <FaSync className={`me-1 ${loading ? 'fa-spin' : ''}`} />
                  Atualizar
                </Button>
              </div>
            </div>
          </div>
          <div className="card-body">
            {/* Filtros de vencimento */}
            <div className="mb-3">
              <ButtonGroup size="sm" className={windowWidth < 768 ? "d-grid gap-2" : "w-100"}>
                <Button
                  variant={filtroVencimento === 'vence_hoje' ? 'danger' : 'outline-danger'}
                  onClick={() => setFiltroVencimento('vence_hoje')}
                  className="d-flex align-items-center justify-content-center"
                >
                  <FaCalendarDay className="me-1" />
                  Vence Hoje
                  {contadores.vence_hoje > 0 && (
                    <span className="badge bg-light text-dark ms-2">
                      {contadores.vence_hoje}
                    </span>
                  )}
                </Button>
                <Button
                  variant={filtroVencimento === 'vence_amanha' ? 'warning' : 'outline-warning'}
                  onClick={() => setFiltroVencimento('vence_amanha')}
                  className="d-flex align-items-center justify-content-center"
                >
                  <FaCalendarPlus className="me-1" />
                  Vence Amanhã
                  {contadores.vence_amanha > 0 && (
                    <span className="badge bg-light text-dark ms-2">
                      {contadores.vence_amanha}
                    </span>
                  )}
                </Button>
                <Button
                  variant={filtroVencimento === 'vencidos' ? 'secondary' : 'outline-secondary'}
                  onClick={() => setFiltroVencimento('vencidos')}
                  className="d-flex align-items-center justify-content-center"
                >
                  <FaExclamationTriangle className="me-1" />
                  Vencidos
                  {contadores.vencidos > 0 && (
                    <span className="badge bg-light text-dark ms-2">
                      {contadores.vencidos}
                    </span>
                  )}
                </Button>
                <Button
                  variant={filtroVencimento === 'proximos_dias' ? 'info' : 'outline-info'}
                  onClick={() => setFiltroVencimento('proximos_dias')}
                  className="d-flex align-items-center justify-content-center"
                >
                  <FaClock className="me-1" />
                  Próximos {diasPersonalizados} dias
                  {contadores.proximos_dias > 0 && (
                    <span className="badge bg-light text-dark ms-2">
                      {contadores.proximos_dias}
                    </span>
                  )}
                </Button>
              </ButtonGroup>
            </div>

            {/* Filtros avançados */}
            {filtroAvancado && (
              <div className="mb-3 p-3 bg-light rounded">
                <Row>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Dias personalizados</Form.Label>
                      <Form.Control
                        type="number"
                        size="sm"
                        min="1"
                        max="365"
                        value={diasPersonalizados}
                        onChange={(e) => setDiasPersonalizados(parseInt(e.target.value) || 7)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            )}

            {/* Lista de parcelas */}
            <div className="table-responsive">
              {parcelasFiltradas.length > 0 ? (
                <table className="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th>Cliente</th>
                      <th>Parcela</th>
                      <th>Valor</th>
                      <th>Vencimento</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {parcelasFiltradas.map((parcela, index) => (
                      <tr key={parcela.id || index} className={getRowClass(parcela)}>
                        <td>
                          <div className="text-truncate" style={{ maxWidth: '150px' }}>
                            {parcela.clienteNome}
                          </div>
                        </td>
                        <td>
                          <small className="text-muted">
                            {parcela.numeroParcela}/{parcela.totalParcelas}
                          </small>
                        </td>
                        <td>
                          <strong>{formatarMoeda(parcela.valor)}</strong>
                        </td>
                        <td>
                          <small>{formatarData(parcela.dataVencimento)}</small>
                        </td>
                        <td>
                          {renderStatusParcela(parcela)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="text-center py-4">
                  <p className="text-muted mb-0">
                    {loading ? (
                      <>
                        <FaSpinner className="fa-spin me-2" />
                        Carregando parcelas...
                      </>
                    ) : (
                      'Nenhuma parcela encontrada para o filtro selecionado'
                    )}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

